import { pathQueryParams } from '../../../../../shared/constants/pathQueryParams';
import { CUSTOMER_PROFILE_TAB_NAMES } from '../../../../../shared/constants/tabNames/CUSTOMER_PROFILE_TAB_NAMES';

export const getLinkToCustomerProfile = (customerId) => {
  const { initialTabName } = pathQueryParams;
  const { LAB_TESTS } = CUSTOMER_PROFILE_TAB_NAMES;

  return `#!/customer-profile/${customerId}?${initialTabName}=${LAB_TESTS}`;
};
